import script from "./Categories.vue?vue&type=script&setup=true&lang=ts"
export * from "./Categories.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__